import http from "./http";
import store from "store/dist/store.modern";

const requestPasswordChange = (email: string) => {
  return http.post("/request-password-change", { email });
};

const saveToken = (token: string) => store.set("access_token", token);

const getToken = () => store.get("access_token");

const saveEmail = (email: string) => store.set("email", email);

const getEmail = () => store.get("email");

const removeToken = () => store.remove("access_token");

export {
  requestPasswordChange,
  saveToken,
  saveEmail,
  getToken,
  getEmail,
  removeToken,
};
